export default __webpack_public_path__ + "static/media/human.a34596ff.png";